export default __webpack_public_path__ + "static/media/terminate-2.858db6a7.png";